import { IPagination } from "../types/pagination";

export const DEFAULT_EXPORT_PAGINATION: IPagination = {
  page: 1,
  limit: 100_000_000,
};
